import { LatLng } from 'leaflet';
import { db } from '../DBUtils';
import { Place } from '../Place';
import { PrefsPayload } from '../../state/prefsSlice';
import { ITaxonomy } from '../interfaces/ITaxonomy';
import _ from 'lodash';

export type PlaceQuery = {
	filter?: {
		id?: number[];
		title?: string;
		featured?: boolean;
		has_topics?: ITaxonomy[]; // topic slugs
		distance_from?: { location: LatLng; radius: number };
	};
	prefilter?: PrefsPayload;
	sort?: {
		distance_from?: LatLng;
		featured?: boolean;
	};
	limit?: number;
};

export type PlaceList = {
	query?: PlaceQuery;
	places: Place[];
	success: boolean;
	reason?: string;
};

export class PlaceFactory {
	public static getEmpty() {
		const empty_set: PlaceList = {
			places: [],
			success: true,
		};
		return empty_set;
	}

	public static async getAll() {
		return db.places
			.toArray()
			.then(async (my_places) => {
				let decorated = await Place.decorate(my_places);
				let retval: PlaceList = {
					places: decorated,
					success: true,
				};
				// console.log('<PlaceFactory>getAll : ', retval);

				return retval;
			})
			.catch((reason) => {
				let retval: PlaceList = {
					places: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}

	public static filter(poi_list: PlaceList, query: PlaceQuery) {
		// TODO : Query Not Implemented Yet
		const new_list = PlaceFactory.getEmpty();
		let prefilter_topics = [];

		new_list.query = query;
		new_list.success = true;

		if (query.filter) {
			if (
				query?.prefilter?.topics &&
				query?.prefilter?.topics.length > 0
			) {
				prefilter_topics = query.prefilter.topics;

				query.filter.has_topics = _.unionWith(
					query.filter?.has_topics ?? [],
					prefilter_topics,
					_.isEqual,
				);
			}
		}

		if (query.filter !== undefined) {
			new_list.places = poi_list.places.filter((place) => {
				let include_record = true;
				if (query.filter) {
					// Check for id match
					if (query.filter.id !== undefined) {
						if (!query.filter.id.includes(place.id)) {
							include_record = false;
						}
					}
					// Check for 'Featured'
					if (query.filter.featured !== undefined) {
						if (place.featured !== query.filter.featured)
							include_record = false;
					}
					// Check for 'string' in title / short_description / topics / activities
					if (query.filter.title !== undefined) {
						const searchTarget = [];

						searchTarget.push(place.title);
						searchTarget.push(place.short_description);
						place.topics.forEach((topic) => {
							searchTarget.push(topic.title);
						});

						if (
							searchTarget
								.join(' ')
								.toLowerCase()
								.indexOf(query.filter.title.toLowerCase()) ===
							-1
						)
							include_record = false;
					}
					// Check for 'topics' - QType : anyOf
					if (query.filter.has_topics !== undefined) {
						if (query.filter.has_topics.length > 0) {
							let include_by_topic = false;
							if (
								_.intersectionWith(
									place.topics,
									query.filter.has_topics,
									_.isEqual,
								).length > 0
							) {
								include_by_topic = true;
							}
							include_record = include_by_topic;
						}
					}

					// Check for 'proximity'
					if (query.filter.distance_from !== undefined) {
					}
				}
				return include_record;
			});
		}
		return new_list;
	}
}
